<template>
  <v-navigation-drawer
    v-model="navState.drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-list>
      <v-list-item-group v-model="item">
        <v-list-item
          :disabled="item.disabled ? true : false"
          :to="item.to"
          v-for="(item, i) in displayableItems"
          :key="i"
          exact-active-class="active-link"
        >
          <v-list-item-icon class="mr-2">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { navigationItems } from "@/config/navigation";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    item: null,
    items: navigationItems,
  }),

  computed: {
    ...mapGetters(["navState", "isLoggedIn", "currentUser"]),
    displayableItems() {
      const routes = this.$router.options.routes;

      return this.items.filter((item) => {
        const route = routes.find((r) => item.to.name == r.name);
        if (route) {
          if (route.meta && route.meta.authorize) {
            return this.isAuthorized(route.meta.authorize);
          } else {
            return true;
          }
        } else {
          return null;
        }
      });
    },
  },
  methods: {
    isAuthorized(roles) {
      if (this.currentUser) {
        const userRoles = this.currentUser.roles;

        if (!roles || roles.length < 1) {
          return true;
        }
        if (userRoles && userRoles.length > 0) {
          return userRoles.some((r) => roles.includes(r));
        } else {
          // this.addErrorMessage("Unauthorized Access");
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.active-link {
  color: var(--v-primary-base);
}
</style>
